"use strict";

var setLoading =
	window.LoadingStore && window.LoadingStore.setLoading
		? window.LoadingStore.setLoading
		: function () {};

function debounce(func, wait) {
	let timeout;
	return function (...args) {
		const context = this;
		clearTimeout(timeout);
		timeout = setTimeout(() => func.apply(context, args), wait);
	};
}
var Ajaxinate = function ajaxinateConstructor(config) {
	var settings = config || {};

	/*
		pagination: Selector of pagination container
		method: [options are 'scroll', 'click']
		container: Selector of repeating content
		offset: 0, offset the number of pixels before the bottom to start loading more on scroll
		loadingText: 'Loading', The text changed during loading
		callback: null, function to callback after a new page is loaded
    */

	var defaultSettings = {
		pagination: "#AjaxinatePagination",
		method: "scroll",
		container: "#AjaxinateLoop",
		offset: 1500,
		loadingText: "Loading",
		callback: null,
	};
	this.settings = Object.assign(defaultSettings, settings);

	this.addScrollListeners = this.addScrollListeners.bind(this);
	this.addClickListener = this.addClickListener.bind(this);
	this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
	this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
	this.destroy = this.destroy.bind(this);

	this.containerElement = document.querySelector(this.settings.container);
	this.paginationElement = document.querySelector(this.settings.pagination);

	if (this.paginationElement) {
		this.checkIfPaginationInView();
	}
	this.initialize();
};

Ajaxinate.prototype.initialize =
	function initializeTheCorrectFunctionsBasedOnTheMethod() {
		if (this.containerElement) {
			var initializers = {
				click: this.addClickListener,
				scroll: this.addScrollListeners,
			};
			initializers[this.settings.method]();
		}
	};

Ajaxinate.prototype.addScrollListeners =
	function addEventListenersForScrolling() {
		if (this.paginationElement) {
			this.debouncedCheckIfPaginationInView = debounce(
				this.checkIfPaginationInView.bind(this),
				150
			);
			document.addEventListener(
				"scroll",
				this.debouncedCheckIfPaginationInView,
				{ passive: true }
			);
			window.addEventListener(
				"resize",
				this.debouncedCheckIfPaginationInView
			);
			window.addEventListener(
				"orientationchange",
				this.debouncedCheckIfPaginationInView
			);
		}
	};

Ajaxinate.prototype.addClickListener = function addEventListenerForClicking() {
	if (this.paginationElement) {
		this.nextPageLinkElement = this.paginationElement.querySelector("a");
		this.clickActive = true;
		if (this.nextPageLinkElement !== null) {
			this.nextPageLinkElement.addEventListener(
				"click",
				this.stopMultipleClicks
			);
		}
	}
};

Ajaxinate.prototype.stopMultipleClicks = function handleClickEvent(event) {
	event.preventDefault();
	if (this.clickActive) {
		this.nextPageLinkElement.innerHTML = this.settings.loadingText;
		this.nextPageUrl = this.nextPageLinkElement.href;
		this.clickActive = false;
		this.loadMore();
	}
};

Ajaxinate.prototype.checkIfPaginationInView = function handleScrollEvent() {
	if (this.isLoading) return;
	if (
		!this.paginationElement ||
		!document.body.contains(this.paginationElement)
	) {
		return;
	}

	try {
		var rect = this.paginationElement.getBoundingClientRect();
		var isMobile =
			window.matchMedia &&
			window.matchMedia("(max-width: 740px)").matches;
		var preloadDistance = isMobile ? 1000 : 1500;
		var preloadTop = rect.top - preloadDistance;

		if (preloadTop <= window.innerHeight * (isMobile ? 2 : 2.5)) {
			this.nextPageLinkElement =
				this.paginationElement.querySelector("a");
			if (
				this.nextPageLinkElement &&
				!this.paginationElement.hasAttribute("ed-loading")
			) {
				this.loadMore();
			}
		}
	} catch (e) {
		console.warn("Ajaxinate: Error checking pagination position:", e);
	}
};

Ajaxinate.prototype.loadMore =
	function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
		if (this.isLoading) return;
		if (!this.paginationElement || !this.nextPageLinkElement) {
			return;
		}

		this.isLoading = true;
		this.paginationElement.setAttribute("ed-loading", "true");
		setLoading(true);

		try {
			document.body.setAttribute("data-ajaxinate-loading", "1");
		} catch (e) {
			// Silent fail
		}

		try {
			document.dispatchEvent(
				new CustomEvent("ed:ajaxinate:loading", {
					bubbles: true,
				})
			);
		} catch (e) {
			// Silent fail
		}
		this.nextPageLinkElement.innerHTML = this.settings.loadingText;
		this.nextPageUrl = this.nextPageLinkElement.href;

		fetch(this.nextPageUrl)
			.then((response) => {
				if (!response.ok)
					throw new Error("Network response was not ok");
				return response.text();
			})
			.then((responseText) => {
				const parser = new DOMParser();
				const responseDocument = parser.parseFromString(
					responseText,
					"text/html"
				);

				const newContainer = responseDocument.querySelector(
					this.settings.container
				);
				const newPagination = responseDocument.querySelector(
					this.settings.pagination
				);

				if (newContainer && newPagination) {
					this.containerElement.insertAdjacentHTML(
						"beforeend",
						newContainer.innerHTML
					);
					this.paginationElement.innerHTML = newPagination.innerHTML;
					this.paginationElement.removeAttribute("ed-loading");
					this.isLoading = false;
					setLoading(false);

					try {
						document.body.removeAttribute("data-ajaxinate-loading");
					} catch (e) {
						// Silent fail
					}

					if (
						this.settings.callback &&
						typeof this.settings.callback === "function"
					) {
						this.settings.callback(responseDocument);
					}

					document.dispatchEvent(
						new CustomEvent("ajaxinate.page:load", {
							detail: { content: newContainer },
						})
					);

					this.initialize();
				} else {
					throw new Error("Invalid response structure");
				}
			})
			.catch((error) => {
				console.error("Ajaxinate error:", error);
				if (
					this.paginationElement &&
					document.body.contains(this.paginationElement)
				) {
					this.paginationElement.removeAttribute("ed-loading");
				}
				this.isLoading = false;
				setLoading(false);

				try {
					document.body.removeAttribute("data-ajaxinate-loading");
				} catch (err) {
					// Silent fail
				}
			});
	};

Ajaxinate.prototype.removeClickListener = function removeClickEventListener() {
	if (this.nextPageLinkElement) {
		this.nextPageLinkElement.removeEventListener(
			"click",
			this.stopMultipleClicks
		);
	}
};

Ajaxinate.prototype.removeScrollListener =
	function removeScrollEventListener() {
		document.removeEventListener(
			"scroll",
			this.debouncedCheckIfPaginationInView
		);
		window.removeEventListener(
			"resize",
			this.debouncedCheckIfPaginationInView
		);
		window.removeEventListener(
			"orientationchange",
			this.debouncedCheckIfPaginationInView
		);
	};

Ajaxinate.prototype.destroy = function () {
	this.removeScrollListener();
	this.containerElement = null;
	this.paginationElement = null;
	this.nextPageLinkElement = null;
};
